import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { jUserLittle, WidgetPresenceContent } from 'jamespot-user-api';
import React from 'react';
import { useIntl } from 'react-intl';
import {
    CSSWidgetPresenceList,
    CSSWidgetPresenceListItem,
    CSSWidgetPresenceListItemBtn,
    CSSWidgetPresenceListItemProgressBar,
    CSSWidgetPresenceLabel,
} from './JRCWidgetPresence.styles';

import { JRCProgressBar } from 'components/JRCProgressBar/JRCProgressBar';
import { Typography } from 'components/JRCTypography/JRCTypography.styles';
import { WidgetAvatarList } from '../components/WidgetAvatarList';

export const JRCWidgetPresence = ({
    limit,
    limitValue,
    userAvailableList,
    userUnavailableList,
    userValue,
    userAvailableTotal = 0,
    userUnavailableTotal = 0,
    isClosed = false,
    handleClickAvailable,
    handleClickUnavailable,
    handleOpenUsersModal,
}: WidgetPresenceContent & {
    userAvailableList: jUserLittle[];
    userUnavailableList: jUserLittle[];
    userValue: number;
    userAvailableTotal: number;
    userUnavailableTotal: number;
    handleClickAvailable: () => void;
    handleClickUnavailable: () => void;
    handleOpenUsersModal: (index: number) => void;
}) => {
    const intl = useIntl();

    return (
        <>
            <CSSWidgetPresenceList>
                <CSSWidgetPresenceListItem>
                    <CSSWidgetPresenceListItemBtn
                        onClick={handleClickAvailable}
                        isDisabled={userValue === 0 || !!isClosed}>
                        <JRCIcon name="icon-check" color={userValue === 1 ? 'green' : 'grey3'} />
                        <CSSWidgetPresenceLabel isOn={userValue === 0}>
                            {intl.formatMessage({ id: 'WIDGET_Presence_On' })}
                        </CSSWidgetPresenceLabel>
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                // the 1 value is used to open the modal for the available users
                                handleOpenUsersModal(1);
                            }}>
                            <WidgetAvatarList
                                list={userAvailableList}
                                left={
                                    userAvailableTotal > userAvailableList.length
                                        ? userAvailableTotal - userAvailableList.length
                                        : 0
                                }
                            />
                        </div>
                    </CSSWidgetPresenceListItemBtn>
                </CSSWidgetPresenceListItem>
                <CSSWidgetPresenceListItem>
                    <CSSWidgetPresenceListItemBtn
                        onClick={handleClickUnavailable}
                        isDisabled={userValue === 1 || !!isClosed}>
                        <JRCIcon name="icon-close" color={userValue === 0 ? 'orange' : 'grey3'} />
                        <CSSWidgetPresenceLabel isOn={userValue === 0}>
                            {intl.formatMessage({ id: 'WIDGET_Presence_Off' })}
                        </CSSWidgetPresenceLabel>
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                // the 0 value is used to open the modal for the unavailable users
                                handleOpenUsersModal(0);
                            }}>
                            <WidgetAvatarList
                                list={userUnavailableList}
                                left={
                                    userUnavailableTotal > userUnavailableList.length
                                        ? userUnavailableTotal - userUnavailableList.length
                                        : 0
                                }
                            />
                        </div>
                    </CSSWidgetPresenceListItemBtn>
                </CSSWidgetPresenceListItem>
            </CSSWidgetPresenceList>
            {limit && limitValue && (
                <CSSWidgetPresenceListItemProgressBar>
                    <Typography size={'m'}>
                        {intl.formatMessage(
                            { id: 'WIDGET_Presence_Availability' },
                            { max: limitValue - userAvailableTotal },
                        )}
                    </Typography>
                    <JRCProgressBar value={userAvailableTotal} total={limitValue} />
                </CSSWidgetPresenceListItemProgressBar>
            )}
        </>
    );
};
